<nav
  *ngIf="user$ | async as user"
  class="fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700"
>
  <div class="px-3 py-3 lg:px-5 lg:pl-3">
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-start">
        <button
          id="toggleSidebarMobile"
          aria-expanded="true"
          aria-controls="sidebar"
          class="p-2 text-gray-600 rounded cursor-pointer lg:hidden hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 dark:focus:bg-gray-700 focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <svg
            id="toggleSidebarMobileHamburger"
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <svg
            id="toggleSidebarMobileClose"
            class="hidden w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
        <a href="/admin-panel" class="flex ml-2 md:mr-24">
          <img
            src="assets/images/header-logo.png"
            class="h-32 mr-3"
            alt="Header logo"
          />
        </a>
        <button
          data-dropdown-toggle="clinics-dropdown"
          class="relative mt-1 ml-3 text-center w-[220px] bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        >
          <span
            class="text-xs absolute left-0 -translate-y-4 top-0 w-full text-center opacity-60"
            >активна клиника</span
          >
          {{ activeClinic ? activeClinic.name : "Клиники" }}
          <icon-wrap
            name="caret-down"
            class="ml-auto absolute right-0 mr-2"
          ></icon-wrap>
        </button>
        <div
          id="clinics-dropdown"
          class="z-10 hidden w-[220px] mt-1 text-center bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        >
          <div class="flex flex-col divide-black last:border-0">
            <button
              [ngClass]="{
                'font-bold pointer-events-none':
                  clinic._id === user.activeClinic
              }"
              (click)="setActiveClinic(i)"
              *ngFor="let clinic of clinics; let i = index"
              class="text-start px-4 w-full py-2 hover:bg-gray-200 border-b border-gray-300"
            >
              {{ clinic.name }}
            </button>
            <button
            *ngIf="canAddClinic"
              [replaceUrl]="true"
              routerLink="/admin-panel/clinics/ADD/general-info"
              class="flex flex-row items-center text-start px-4 w-full py-2 text-orange-200 font-bold"
            >
              Добави клиника
              <icon-wrap
                [parts]="[
                  {
                    element: 'path',
                    fill: 'white'
                  }
                ]"
                name="plus-white"
                class="w-7 h-7 flex items-center justify-center rounded-full bg-orange-100 ml-auto"
              ></icon-wrap>
            </button>
          </div>
        </div>
        <div class="hidden lg:block lg:pl-3.5">
          <label for="topbar-search" class="sr-only">Търсене</label>
          <div class="relative mt-1 lg:w-96">
            <div
              class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
            >
              <svg
                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div class="flex flex-row items-center gap-2">
              <div
                data-dropdown-placement="bottom-start"
                data-dropdown-toggle="header-search-results"
                class="w-full"
              >
                <input
                  [formControl]="search"
                  [ngClass]="{
                    'opacity-40 pointer-events-none': false
                  }"
                  type="text"
                  id="topbar-search"
                  class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  [placeholder]="searchPlaceholders[type]"
                />
              </div>
              <button data-dropdown-toggle="header-search-types">
                <icon-wrap name="filter"></icon-wrap>
              </button>
              <div
                id="header-search-results"
                class="gap-y-2 z-50 hidden my-4 text-base bg-white w-full divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600"
              >
                <ng-container *ngIf="search$ | async as results">
                  <div class="flex flex-col gap-y-2">
                    <ng-container *ngFor="let item of results">
                      <ng-container *ngIf="getRedirectUrl(item) as route">
                        <a
                          [href]="route.url"
                          [routerLink]="route.url"
                          [queryParams]="route.queryParams"
                          [replaceUrl]="true"
                          (click)="flowbiteSrv.hideAllDropdown()"
                          class="last:border-transparent border-b border-black flex flex-row items-center p-2 gap-x-2 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                        >
                          <div class="w-10 h-10 rounded-full overflow-hidden">
                            <ng-container
                              *ngIf="type === 'patients' || type === 'stocks'"
                            >
                              <img
                                *ngIf="item.image"
                                [src]="assetUrl + item.image"
                                class="h-full w-full object-cover"
                              />
                            </ng-container>
                          </div>
                          <div class="px-4 py-2 text-sm text-gray-700">
                            <span class="font-bold">
                              {{
                                type === "patients"
                                  ? item.name
                                  : type === "clients"
                                  ? item.names
                                  : item.title
                              }}
                            </span>
                            <span class="ml-2">
                              {{
                                type === "patients"
                                  ? "Порода: " + item.breed
                                  : type === "clients"
                                  ? "Имейл: " + item.email
                                  : "Подходящи за: " + item.suitableFor
                              }}
                            </span>
                            <p class="mt-1">
                              {{
                                type === "patients"
                                  ? "Стопанин: " + item.owner.names
                                  : type === "clients"
                                  ? "Тел. Номер: " + item.telephone
                                  : "Съставки: " + item.ingredients
                              }}
                            </p>
                          </div>
                        </a>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>

              <div
                class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600"
                id="header-search-types"
                data-popper-placement="bottom"
                style="
                  position: absolute;
                  inset: 0px auto auto 0px;
                  margin: 0px;
                "
              >
                <ul class="py-1" role="none">
                  <h1 class="px-3 pb-2 border-b border-black">Филтър по:</h1>
                  <li
                    (click)="setType('patients')"
                    [ngClass]="{
                      'pointer-events-none font-bold': type === 'patients'
                    }"
                  >
                    <a
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      role="menuitem"
                      >Пациенти</a
                    >
                  </li>
                  <li
                    (click)="setType('clients')"
                    [ngClass]="{
                      'pointer-events-none font-bold': type === 'clients'
                    }"
                  >
                    <a
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      role="menuitem"
                      >Стопани</a
                    >
                  </li>
                  <li
                    (click)="setType('stocks')"
                    [ngClass]="{
                      'pointer-events-none font-bold': type === 'stocks'
                    }"
                  >
                    <a
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      role="menuitem"
                      >Продукти</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center">
        <div class="hidden mr-3 -mb-1 sm:block">
          <span></span>
        </div>

        <button
          id="toggleSidebarMobileSearch"
          type="button"
          class="p-2 text-gray-500 rounded-lg lg:hidden hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
        >
          <span class="sr-only">Търсене</span>

          <svg
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>

        <button
          id="theme-toggle"
          data-tooltip-target="tooltip-toggle"
          type="button"
          class="text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-2.5"
        >
          <svg
            id="theme-toggle-dark-icon"
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            ></path>
          </svg>
          <svg
            id="theme-toggle-light-icon"
            class="hidden w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
              fill-rule="evenodd"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
        <div
          id="tooltip-toggle"
          role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip"
          data-popper-placement="bottom"
          style="
            position: absolute;
            inset: 0px auto auto 0px;
            margin: 0px;
            transform: translate(1747px, 63px);
          "
        >
          Toggle dark mode
          <div
            class="tooltip-arrow"
            data-popper-arrow=""
            style="
              position: absolute;
              left: 0px;
              transform: translate(69px, 0px);
            "
          ></div>
        </div>

        <div class="flex items-center ml-3">
          <div>
            <button
              type="button"
              class="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
              id="user-menu-button-2"
              aria-expanded="false"
              data-dropdown-toggle="dropdown-2"
            >
              <span class="sr-only">Open user menu</span>
              <img
                class="w-8 h-8 rounded-full"
                src="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                alt="user photo"
              />
            </button>
          </div>

          <div
            class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600"
            id="dropdown-2"
            data-popper-placement="bottom"
            style="
              position: absolute;
              inset: 0px auto auto 0px;
              margin: 0px;
              transform: translate(1867px, 61px);
            "
          >
            <div class="px-4 py-3" role="none">
              <p class="text-sm text-gray-900 dark:text-white" role="none">
                {{ user.names }}
              </p>
              <p
                class="text-sm font-medium text-gray-900 truncate dark:text-gray-300"
                role="none"
              >
                {{ user.email }}
              </p>
            </div>
            <ul class="py-1" role="none">
              <li (click)="logout()">
                <a
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                  role="menuitem"
                  >Излез</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
